import React from 'react';
import { Button, Typography, Panel } from '@icecreamsocial/components';
import { RightArrowIcon } from '../SupportedIcons';
import { useIntl } from 'react-intl';

export const OrderIdDisplay = ({ orderId, onOrderClicked, ...rest }) => {
	const intl = useIntl();

	/**
	 * localization
	 */
	const ORDER_CONFIRMED = intl.formatMessage(
		{
			id: 'order.confirmed',
			defaultMessage: 'Order #{orderId} confirmed!',
			description:
				"Status message showing confirmation of a user's order with their orderId",
		},
		{
			orderId,
		}
	);

	const ORDER_DETAILS = intl.formatMessage({
		id: 'order.details',
		defaultMessage: 'See Order Details',
		description: 'Minor call to action for users to see their order details',
	});

	return (
		<Panel
			textColor='bodyInverse'
			backgroundColor='rgba(0,0,0,.75)'
			border='none'
			{...rest}
		>
			<Panel.Body>
				<Typography.Span display='block' typoSize='1.1em' typoHeight='1'>
					{ORDER_CONFIRMED}
				</Typography.Span>
				<Button
					as={Typography.Span}
					display='inline-flex'
					alignItems='center'
					textDecoration='underline'
					border='0'
					hoverShadow='none'
					shadow='none'
					padding='0'
					marginTop='sm'
					onClick={onOrderClicked}
				>
					{ORDER_DETAILS} <RightArrowIcon size={18} marginLeft='sm' />
				</Button>
			</Panel.Body>
		</Panel>
	);
};
